import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Clock } from 'lucide-react';
export function Garantia() {
  return <section className="py-12 px-4 bg-slate-50 border-b border-slate-200" data-id="element-33">
      <div className="max-w-3xl mx-auto" data-id="element-34">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-12" data-id="element-35">
          <div className="flex items-center gap-3" data-id="element-36">
            <Clock className="w-8 h-8 text-[#0f4c5c]" data-id="element-37" />
            <span className="text-xl font-bold text-slate-800" data-id="element-38">
              Acceso inmediato
            </span>
          </div>

          <div className="hidden md:block w-px h-12 bg-slate-300" data-id="element-39"></div>

          <div className="flex items-center gap-3" data-id="element-40">
            <ShieldCheck className="w-8 h-8 text-[#0f4c5c]" data-id="element-41" />
            <span className="text-xl font-bold text-slate-800" data-id="element-42">
              Garantía 7 días
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}